import Cookies from 'universal-cookie';

/**
 * Create our Cookies Context client side
 * Server side rendering would create its Cookie Context from request
 * /!\ All client side cookie operations must be done using this context ! /!\
 */
export default new Cookies();
